import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GeoAlertInterface {
  flag: "1" | "2" | "3"| "4";
}

const initialState: GeoAlertInterface = {
  flag: "1",
};

const geoalertSlice = createSlice({
  name: "geoalert",
  initialState,
  reducers: {
    updateGeoFlag: (state, action: PayloadAction<GeoAlertInterface>) => {
      state.flag = action.payload.flag;
    },
  },
});

export const { updateGeoFlag } = geoalertSlice.actions;

export default geoalertSlice.reducer;
